export const MAINTENANCE_DETECTED_EVENT = 'app:maintenance-detected';
// Глобальный флаг-буфер: если событие maintenance пришло до подписки роутера, он прочитает его позже.
export const MAINTENANCE_PENDING_FLAG = '__wsMaintenanceDetectedPending';

export const isMaintenanceError = (error) => {
  const status = error?.response?.status;
  const responseData = error?.response?.data;

  const result = responseData?.result;
  const message = responseData?.meta?.data?.message || responseData?.message;
  const trace = responseData?.meta?.data?.trace || responseData?.trace;

  return (
    status === 503 ||
    (result === 'error' && message === 'Service Unavailable') ||
    (typeof trace === 'string' && trace.includes('PreventRequestsDuringMaintenance'))
  );
};

// Помечает pending-флаг и уведомляет подписчиков о включении maintenance.
export const emitMaintenanceDetected = () => {
  if (typeof window === 'undefined') return;

  window[MAINTENANCE_PENDING_FLAG] = true;
  window.dispatchEvent(new CustomEvent(MAINTENANCE_DETECTED_EVENT));
};
